// lets us dispatch() functions
import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import { save, load } from 'redux-localstorage-simple';
import rootReducer from './redux/reducers/index';
import URC from 'ui-react-common';

const { routingMiddleware } = URC.middleware;
const loggerMiddleware = createLogger();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const redux_localstorage_namespace = 'rocketloans_redux';

function applyAllMiddleware() {
    // only log in dev
    if (process.env.NODE_ENV === 'development') {
        return applyMiddleware(
            thunkMiddleware,
            routingMiddleware,
            loggerMiddleware,
            saveToLocalStorageWrapper
        );
    } else {
        return applyMiddleware(thunkMiddleware, routingMiddleware, save());
    }
}

const store = createStore(
    rootReducer,
    load({ namespace: redux_localstorage_namespace }),
    composeEnhancers(applyAllMiddleware())
);


function saveToLocalStorageWrapper({ dispatch, getState }) {
    const allStates = getState();
    const states = Object.keys(allStates).filter((key) => !allStates[key].ignoreLocalStorage);

    return save({
        namespace: redux_localstorage_namespace,
        states,
    })({ dispatch, getState });
}

export default store;
